
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import TextFieldWithValidation from '../../components/inputs/TextFieldWithValidation';
import PhoneNumberInputWithValidation from '~/components/inputs/PhoneNumberInputWithValidation.vue';

import countries from '~/static/countries.json';
import cloneDeep from 'lodash.clonedeep';

export default {
  name: 'Register',
  components: {
    TextFieldWithValidation,
    ValidationObserver,
    ValidationProvider,
    PhoneNumberInputWithValidation,
  },
  layout: 'authentication',
  data() {
    return {
      loading: false,
      signUpData: {
        email: '',
        company: '',
        phone_number: {
          prefix: '',
          number: '',
        },
        primary_use_case: '',
        password: '',
        full_name: '',
        privacy: '',
        newsletter_subscription: true,
      },
      countries: cloneDeep(countries),
      useCaseList: [
        'Accounts payable',
        'Sales order management',
        'Logistics',
        'Insurance claims',
        'Marketing purposes - customer loyalty programmes',
        'Other',
      ],
      primary_use_case_other: '',
    };
  },
  watch: {
    'signUpData.primary_use_case': function () {
      this.primary_use_case_other = '';
    },
  },
  methods: {
    showResponseErrors(response) {
      if (response?.data?.code === 'ALREADY_EXISTS') {
        this.$refs.obs.setErrors({
          email: 'Account with this email already exists.',
        });
      } else if (response?.data?.code === 'VALIDATION_EXCEPTION') {
        try {
          response?.data?.details.forEach((detail) => {
            const key = detail.loc[1];
            const message = JSON.parse(detail.msg.replace(/'/g, '"')).Message;
            this.$refs.obs.setErrors({
              [key]: message,
            });
          });
        } catch (e) {
          // Ignore
        }
      }
    },
    async signUp() {
      try {
        this.$refs.obs.validate();
        if (this.$refs.obs.invalid) {
          return;
        }

        this.loading = true;
        let phoneNumber = '';
        if (
          this.signUpData.phone_number.prefix &&
          this.signUpData.phone_number.number
        ) {
          phoneNumber =
            String(this.signUpData.phone_number.prefix) +
            String(this.signUpData.phone_number.number);
        }
        const payload = {
          ...this.signUpData,
          phone_number: phoneNumber,
          primary_use_case: this.primary_use_case_other
            ? this.primary_use_case_other
            : this.signUpData.primary_use_case,
          email: this.signUpData.email.toLowerCase(),
          company: this.signUpData.company,
          terms_accepted: true,
        };

        await this.$store.dispatch('user/signUp', payload);
        await this.$router.push('/register/success');
      } catch (err) {
        this.showResponseErrors(err.response);
      } finally {
        this.loading = false;
      }
    },
  },
};
